import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useDashboard = () => {
  const getRecentAnnouncements = useCallback(async (val, cellId, userId) => {
    try {
      const values = { departmentId: val, cellId: cellId, userId: userId };
      return await ajax.post(`dashboard/get-recent-announcements`, values);
    } catch (error) {
      return error;
    }
  });

  const getRecentMyCellGlobalGivingCauses = useCallback(async (val) => {
    try {
      const values = { cellId: val };
      return await ajax.post(`dashboard/get-my-cells-recent-global-giving-causes`, values);
    } catch (error) {
      return error;
    }
  });

  const getCompanyQuarterlyGoal = useCallback(async (values) => {
    try {
      return await ajax.post(`dashboard/get-company-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyQuarterlyGoal = useCallback(async (values) => {
    try {
      return await ajax.post(`dashboard/get-my-professional-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellQuarterlyGoal = useCallback(async (values) => {
    try {
      return await ajax.post(`dashboard/get-cell-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getLogiwareTotalFileList = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-logiware-total-files`, val);
    } catch (error) {
      return error;
    }
  });

  const getVectorGlobalHealthReport = useCallback(
    async (val, countryId, vectorId, loggedInUsercellId) => {
      try {
        const values = {
          cellId: val,
          countryId: countryId,
          vectorId: vectorId,
          loggedInUsercellId: loggedInUsercellId,
        };
        return await ajax.post(`dashboard/get-Vector-global-health-report`, values);
      } catch (error) {
        return error;
      }
    },
  );

  const getVectorGlobalHealthQuestionReport = useCallback(async (val, countryId, qid, vectorId) => {
    try {
      const values = { cellId: val, countryId: countryId, questionId: qid, vectorId: vectorId };
      return await ajax.post(`dashboard/get-Vector-global-health-question-report`, values);
    } catch (error) {
      return error;
    }
  });

  const getCountry = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-filter-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCountryDashboard = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-filter-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCellData = useCallback(async (countryId) => {
    try {
      const val = { countryId: countryId };
      let result = await ajax.post(`user/get-filter-cell-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getTotalFileListFromLogiware = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-files-list`, val);
    } catch (error) {
      return error;
    }
  });

  const getFileManagementMyCellTable = useCallback(async (val) => {
    try {
      const values = { cellValue: val?.cellValue, countryTitle: val?.countryTitle };
      return await ajax.post(`logiware/get-file-management-my-cell-table`, values);
    } catch (error) {
      return error;
    }
  });
  const getMyLogiwareDetails = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName, countryTitle: val?.countryTitle };
      return await ajax.post(`logiware/get-my-logiware-details`, values);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileWithDate = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-average-gross-profit`, values);
    } catch (error) {
      return error;
    }
  });

  const getCompanyPieDataWithDate = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-company-pie-chart-data`, values);
    } catch (error) {
      return error;
    }
  });
  const getCompanyPieChartChangeInData = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-company-pie-chart-change-in-data`, values);
    } catch (error) {
      return error;
    }
  });

  const getCompanyFilesYearToDate = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-company-files-year-to-date`, val);
    } catch (error) {
      return error;
    }
  });

  const getCompanyFilesLastYearToDate = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-company-files-last-year-to-date`, val);
    } catch (error) {
      return error;
    }
  });

  const getCountryPieChartData = useCallback(async (val) => {
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve([]);
      }, 30000); // 30 seconds
    });

    try {
      const response = await Promise.race([
        ajax.post(`logiware/get-country-pie-chart-data`, val),
        timeout,
      ]);

      return response;
    } catch (error) {
      return error;
    }
  });

  const getCountryPieChartChangeInData = useCallback(async (val) => {
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve([]);
      }, 30000); // 30 seconds
    });

    try {
      const response = await Promise.race([
        ajax.post(`logiware/get-country-pie-chart-change-in-data`, val),
        timeout,
      ]);

      return response;
    } catch (error) {
      return error;
    }
  });

  const getHistoricRevenue = useCallback(async (val) => {
    try {
      const values = {
        startYear: val?.startYear,
        endYear: val?.endYear,
        cellValue: val?.cellValue,
        cellId: val?.cellId,
        countryTitle: val?.countryTitle,
      };
      return await ajax.post(`logiware/get-historic-revenue`, values);
    } catch (error) {
      return error;
    }
  });

  const getCountryHistoricRevenue = useCallback(async (val) => {
    try {
      const values = {
        startYear: val?.startYear,
        endYear: val?.endYear,
        cellValue: val?.cellValue,
        cellId: val?.cellId,
      };
      return await ajax.post(`logiware/get-country-historic-revenue`, values);
    } catch (error) {
      return error;
    }
  });

  const getCountryHistoricGross = useCallback(async (val) => {
    try {
      const values = {
        startYear: val?.startYear,
        endYear: val?.endYear,
        cellValue: val?.cellValue,
        cellId: val?.cellId,
      };
      return await ajax.post(`logiware/get-country-historic-gross`, values);
    } catch (error) {
      return error;
    }
  });

  const getHistoricGross = useCallback(async (val) => {
    try {
      const values = {
        startYear: val?.startYear,
        endYear: val?.endYear,
        cellValue: val?.cellValue,
        cellId: val?.cellId,
      };
      return await ajax.post(`logiware/get-historic-gross`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyInvoicingPerformance = useCallback(async (val) => {
    try {
      const values = {
        userName: val?.userName,
        userId: val?.userId,
        countryTitle: val?.countryTitle,
      };
      return await ajax.post(`logiware/get-my-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCellInvoicingPerformance = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        cellId: val?.cellId,
        countryId: val?.countryId,
      };
      return await ajax.post(`logiware/get-my-cell-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCompanyInvoicingPerformance = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        countryId: val?.countryId,
      };
      return await ajax.post(`logiware/get-my-company-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getUserInvoicingDetails = useCallback(async (val) => {
    try {
      const values = {
        userName: val?.userName,
        userId: val?.userId,
        countryTitle: val?.countryTitle,
      };
      return await ajax.post(`logiware/get-user-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellWorkLoadNunbers = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
      };
      return await ajax.post(`logiware/get-cell-workload-numbers`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellWorkLoadList = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-cell-workload-list`, val);
    } catch (error) {
      return error;
    }
  });

  const getCellHistoricTable = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        startYear: val?.startYear,
        endYear: val?.endYear,
      };
      return await ajax.post(`logiware/get-cell-historic-table`, values);
    } catch (error) {
      return error;
    }
  });

  const getClientComplexityScoreTable = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryValue: val?.countryValue,
      };
      return await ajax.post(`logiware/get-client-complexity-score-table`, values);
    } catch (error) {
      return error;
    }
  });

  const getUserHistoricRevenue = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-user-historic-revenue`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyPersonalPerformancePerChangeStatus = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName, countryTitle: val?.countryTitle };
      return await ajax.post(`logiware/get-my-logiware-per-change-details`, values);
    } catch (error) {
      return error;
    }
  });

  const getTotalFileListPerChangeFromLogiware = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-company-file-management-per-change-details`, val);
    } catch (error) {
      return error;
    }
  });

  const getFileManagementMyCellTablePerChangeStatus = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-cell-file-management-per-change-details`, val);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileCompany = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-average-gross-profit-company`, values);
    } catch (error) {
      return error;
    }
  });

  const getCurrentWorkloadGraph = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-current-workload-graph`, val);
    } catch (error) {
      return error;
    }
  });

  const getClientsWithEightyPercentProfit = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-clients-with-eighty-percent-profit`, val, {
        networkParams: { showLoader: false },
      });
    } catch (error) {
      return error;
    }
  });

  return {
    getRecentAnnouncements,
    getRecentMyCellGlobalGivingCauses,
    getCompanyQuarterlyGoal,
    getCellQuarterlyGoal,
    getMyQuarterlyGoal,
    getLogiwareTotalFileList,
    getVectorGlobalHealthReport,
    getVectorGlobalHealthQuestionReport,
    getCountry,
    getCellData,
    getTotalFileListFromLogiware,
    getFileManagementMyCellTable,
    getMyLogiwareDetails,
    getMyInvoicingPerformance,
    getMyCellInvoicingPerformance,
    getMyCompanyInvoicingPerformance,
    getUserInvoicingDetails,
    getCompanyFilesLastYearToDate,
    getCompanyFilesYearToDate,
    getAverageGrossProfitPerFileWithDate,
    getCompanyPieDataWithDate,
    getCountryPieChartData,
    getHistoricRevenue,
    getHistoricGross,
    getCellWorkLoadNunbers,
    getCellWorkLoadList,
    getCellHistoricTable,
    getClientComplexityScoreTable,
    getUserHistoricRevenue,
    getCountryDashboard,
    getMyPersonalPerformancePerChangeStatus,
    getTotalFileListPerChangeFromLogiware,
    getFileManagementMyCellTablePerChangeStatus,
    getCountryPieChartChangeInData,
    getCompanyPieChartChangeInData,
    getAverageGrossProfitPerFileCompany,
    getCurrentWorkloadGraph,
    getCountryHistoricRevenue,
    getCountryHistoricGross,
    getClientsWithEightyPercentProfit,
  };
};
export default useDashboard;
